import { useQuery } from '@tanstack/react-query'
import { Typography } from '@mui/material'

import { IBankConnectionDetail } from '@/types'
import { replaceNullValues } from '@/utils/common'
import { DataTable } from '@/components/UI/DataTable'
import { BankService } from '@/api/services/BankService'
import { connectionQueryKeys } from '@/api/services/connectionQueryKeys'
import { connectionDetailColumns } from './columns'

// Wide enough for every header to sit on its line; a narrower card scrolls the table sideways.
const CONNECTION_DETAIL_MIN_WIDTH = '760px'

type Props = {
  userId: string
  connectionId: string
}

// The connection's sync and identity details as a one-row table, shown with the card rather than
// behind a toggle, so each connection reads its details as soon as the page opens.
export const ConnectionDetail: React.FC<Props> = ({ userId, connectionId }) => {
  const {
    data: connection,
    isLoading,
    error,
  } = useQuery<IBankConnectionDetail>({
    queryKey: connectionQueryKeys.detail(userId, connectionId),
    queryFn: () => BankService.fetchConnectionDetail(userId, connectionId),
    enabled: !!connectionId,
  })

  if (error || (!isLoading && !connection)) {
    return (
      <Typography color="error" textAlign="center" py={2}>
        Failed to load connection details.
      </Typography>
    )
  }

  return (
    <DataTable<IBankConnectionDetail>
      rows={connection ? [replaceNullValues<IBankConnectionDetail>(connection)] : []}
      columns={connectionDetailColumns}
      loadingState={isLoading}
      minWidth={CONNECTION_DETAIL_MIN_WIDTH}
    />
  )
}
